import { render, staticRenderFns } from "./airSamplesExportTable.vue?vue&type=template&id=9b2f71ae"
import script from "./airSamplesExportTable.vue?vue&type=script&lang=js"
export * from "./airSamplesExportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports